/**
 * GSAP ScrollTrigger Plugin Bundle
 * Imports ScrollTrigger plugin for bundling with webpack
 */
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default gsap;
